"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// all keys stored in the cache by this SDK will be prefixed with this value
var CACHE_PREFIX = 'cashier:'; // cached for 1 minute

var CACHE_DURATION_MIN = 1;

function SDK(baseUrl, fetch, cacheInterface, companyId) {
  function _fetchJson(url, options) {
    return new Promise(function ($return, $error) {
      var res, data, text;

      if (options && options.body) {
        options.headers = _objectSpread(_objectSpread({}, options.headers || {}), {}, _defineProperty({}, 'Content-Type', 'application/json'));
      }

      return Promise.resolve(fetch("".concat(baseUrl).concat(url), options)).then(function ($await_3) {
        try {
          res = $await_3;

          if (res.ok) {
            return Promise.resolve(res.json()).then($return, $error);
          }

          if (res.headers.get('Content-Type').indexOf('application/json') !== -1) {
            return Promise.resolve(res.json()).then(function ($await_5) {
              try {
                data = $await_5;
                return $error(_objectSpread({
                  status: res.status
                }, data));
              } catch ($boundEx) {
                return $error($boundEx);
              }
            }, $error);
          }

          function $If_2() {
            return Promise.resolve(res.text()).then(function ($await_6) {
              try {
                text = $await_6;
                return $error(text);
              } catch ($boundEx) {
                return $error($boundEx);
              }
            }, $error);
          }

          return Promise.resolve(res.text()).then(function ($await_6) {
            try {
              text = $await_6;
              return $error(text);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }.bind(this), $error);
    });
  }

  var getKey = function getKey(key) {
    if (companyId) {
      return "".concat(CACHE_PREFIX).concat(companyId, ":").concat(key);
    }

    return "".concat(CACHE_PREFIX).concat(key);
  };

  var _cacheGet = function _cacheGet(key) {
    return cacheInterface.get(getKey(key));
  };

  var _cacheSet = function _cacheSet(key, value, ttl) {
    return cacheInterface.set(getKey(key), value, ttl);
  };

  return {
    covertPointValueToUSDByCountry: function covertPointValueToUSDByCountry(pointValue, country, mediaValueByCountry) {
      if (!pointValue) {
        throw new Error('missing value - cannot convert');
      }

      if (!country) {
        throw new Error('missing country - cannot convert');
      }

      if (!mediaValueByCountry) {
        throw new Error('missing configured media values by country - cannot convert');
      }

      if (!mediaValueByCountry.countries) {
        throw new Error('no countries are configured - cannot convert');
      }

      var selectedCountry = mediaValueByCountry.countries[country];

      if (!selectedCountry) {
        throw new Error("country ".concat(country, " is not configured - cannot convert"));
      }

      var countryMediaValue = selectedCountry.programBudgetValue;

      if (!countryMediaValue) {
        throw new Error("media value for country ".concat(country, " is not configured - cannot convert"));
      }

      return parseFloat(pointValue) * parseFloat(countryMediaValue);
    },
    getMediaValueByCountry: function getMediaValueByCountry() {
      return new Promise(function ($return, $error) {
        var cached, response;
        cached = _cacheGet('media-value');

        if (cached) {
          return $return(cached);
        }

        return Promise.resolve(_fetchJson('/bank/media-value')).then(function ($await_7) {
          try {
            response = $await_7;
            return $return(_cacheSet('media-value', response, CACHE_DURATION_MIN));
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    },
    getAccountInformation: function getAccountInformation(personId) {
      return new Promise(function ($return, $error) {
        var cached, response;
        cached = _cacheGet("account-information-".concat(personId));

        if (cached) {
          return $return(cached);
        }

        return Promise.resolve(_fetchJson("/account/id/".concat(encodeURIComponent(personId), "/account-info"))).then(function ($await_8) {
          try {
            response = $await_8;
            return $return(_cacheSet("account-information-".concat(personId), response, CACHE_DURATION_MIN));
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    },
    getPointBalance: function getPointBalance(personId) {
      return new Promise(function ($return, $error) {
        var cached, response;
        cached = _cacheGet("point-balance-".concat(personId));

        if (cached) {
          return $return(cached);
        }

        return Promise.resolve(_fetchJson("/account/id/".concat(encodeURIComponent(personId), "/point-balance"))).then(function ($await_9) {
          try {
            response = $await_9;
            return $return(_cacheSet("point-balance-".concat(personId), response, CACHE_DURATION_MIN));
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    },
    getStatement: function getStatement(personId, _ref) {
      return new Promise(function ($return, $error) {
        var country, endDate, startDate, cached, body, response;
        country = _ref.country, endDate = _ref.endDate, startDate = _ref.startDate;
        cached = _cacheGet("statement-".concat(personId));

        if (cached) {
          return $return(cached);
        }

        body = JSON.stringify({
          endDate: endDate,
          startDate: startDate,
          country: country
        });
        return Promise.resolve(_fetchJson("/account/id/".concat(encodeURIComponent(personId), "/statement"), {
          method: 'POST',
          body: body
        })).then(function ($await_10) {
          try {
            response = $await_10;
            return $return(_cacheSet("statement-".concat(personId), response, CACHE_DURATION_MIN));
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    },
    search: function search(_ref2) {
      return new Promise(function ($return, $error) {
        var personId, externalId, msParNumber, accountNumber, omParticipantId, searchBody, cached, response;
        personId = _ref2.personId, externalId = _ref2.externalId, msParNumber = _ref2.msParNumber, accountNumber = _ref2.accountNumber, omParticipantId = _ref2.omParticipantId;
        searchBody = JSON.stringify({
          personId: personId,
          externalId: externalId,
          msParNumber: msParNumber,
          accountNumber: accountNumber,
          omParticipantId: omParticipantId
        });
        cached = _cacheGet("search-".concat(searchBody));

        if (cached) {
          return $return(cached);
        }

        return Promise.resolve(_fetchJson('/account/search', {
          method: 'POST',
          body: searchBody
        })).then(function ($await_11) {
          try {
            response = $await_11;
            return $return(_cacheSet("search-".concat(searchBody), response, CACHE_DURATION_MIN));
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    },
    issuePoints: function issuePoints(_ref3) {
      return new Promise(function ($return, $error) {
        var personId, metadata, rewards;
        personId = _ref3.personId, metadata = _ref3.metadata, rewards = _ref3.rewards;
        return Promise.resolve(_fetchJson('/reward/earned', {
          method: 'POST',
          body: JSON.stringify({
            personId: personId,
            metadata: metadata,
            rewards: rewards
          })
        })).then($return, $error);
      });
    },
    getCampaignInfo: function getCampaignInfo(country) {
      return new Promise(function ($return, $error) {
        var cached, query, response;
        cached = _cacheGet("campaign-info-".concat(country || ''));

        if (cached) {
          return $return(cached);
        } // build a query string if country was passed in.


        query = country ? "?country=".concat(encodeURIComponent(country)) : '';
        return Promise.resolve(_fetchJson("/bank/campaign-info".concat(query))).then(function ($await_13) {
          try {
            response = $await_13;
            return $return(_cacheSet("campaign-info-".concat(country || ''), response, CACHE_DURATION_MIN));
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    },
    cancelProcessingReward: function cancelProcessingReward(rewardId) {
      return new Promise(function ($return, $error) {
        return Promise.resolve(_fetchJson("/reward/cancel-reward/".concat(rewardId), {
          method: 'POST'
        })).then($return, $error);
      });
    },
    forceRetryProcessingReward: function forceRetryProcessingReward(rewardId) {
      return new Promise(function ($return, $error) {
        return Promise.resolve(_fetchJson("/reward/retry-reward/".concat(rewardId), {
          method: 'POST',
          body: JSON.stringify({
            forceRetry: true
          })
        })).then($return, $error);
      });
    },
    campaign1099Types: {
      ISSUANCE: 'I',
      REDEMPTION: 'R',
      TERMINATED: 'T'
    },
    enroll: function enroll(participantsToEnroll) {
      return new Promise(function ($return, $error) {
        return Promise.resolve(_fetchJson('/account/enroll', {
          method: 'POST',
          body: JSON.stringify(participantsToEnroll)
        })).then($return, $error);
      });
    }
  };
}

var noCache = {
  get: function get() {
    return undefined;
  },
  set: function set(key, value, lifetimeMins) {
    return value;
  }
};

module.exports = function (url, customFetch) {
  var cacheInterface = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noCache;

  if (typeof customFetch !== 'function') {
    throw new Error("".concat(_typeof(customFetch), " is not a function"));
  }

  return new SDK(url, customFetch, cacheInterface);
};
//# sourceMappingURL=index.js.map